import React from "react";
import { Link } from "react-router-dom";
import FoodData from ".././data/data.json";
import Popup from "./Popup";

const SearchFoodItems = () => {
  return (
    <div>
      <div className="container m-auto py-5">
        <h3>Best Food in Tarn Taran</h3>
        <div className="row">
          {FoodData.map((data) => {
            return (
              <div
                className="col-md-3 mt-3 sfColMobile"
                style={{ cursor: "pointer" }}
                key={data.itemName}
              >
                <div className="">
                  <img
                    src={data.itemImage}
                    className="card-img-top foodImage"
                    alt="..."
                    style={{ borderRadius: "5%" }}
                  />
                  <div className="card-body mt-2">
                    <div className="row align-items-center">
                      <div className="col-md-6">
                        <h6 className="card-title">{data.itemName}</h6>
                      </div>
                      <div className="col-md-6 text-end">
                        <button
                          className="btn btn-success fw-bold me-4"
                          style={{ fontSize: "12px", padding: "2px 8px" }}
                        >
                          3.9
                        </button>
                      </div>
                    </div>
                    <p
                      className="card-text text-secondary"
                      style={{ fontSize: "12px" }}
                    >
                      Price: ₹{data.itemPrice}
                    </p>
                    <Popup data={data} itemName={data.itemName} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SearchFoodItems;
